export default function ($form, callback) {
	var $input = $form.find('input[name="recaptcha_token"]');

	if (!$input.length) {
		$input = jQuery('<input type="hidden" name="recaptcha_token">');
		$form.append($input);
	}

	// Zorg dat grecaptcha ready is
	if (typeof grecaptcha !== 'undefined') {
		grecaptcha.ready(function() {
			grecaptcha.execute(jQuery('meta[name="recaptcha_client_id"]').attr('content'), {action: 'submit'})
				.then(function(token) {
					$input.val(token);
					if (callback) {
						callback(token);
					}
				})
				.catch(function(error) {
					console.error('reCAPTCHA error:', error);
					if (callback) {
						callback(null, error);
					}
				});
		});
	} else {
		if (callback) {
			callback(null, 'grecaptcha not loaded');
		}
	}
};
